import React from 'react';

const RenderOnVisible = (props: any) => {
  const { children, ...restProps } = props;
  const ref: React.RefObject<HTMLDivElement> = React.createRef();

  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
    }

    if ('IntersectionObserver' in window && ref.current) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);

            observer?.unobserve(entry.target);
          }
        });
      });

      setTimeout(
        (ref) => {
          observer.observe(ref);
        },
        500,
        ref.current
      );
    }
  }, []);

  return isVisible ? (
    children
  ) : (
    <section ref={ref} style={{ paddingTop: '120px' }} {...restProps} />
  );
};

export default RenderOnVisible;
